<template>
  <div :style="{ height: '100vh', overflow: 'hidden' }">
    <div class="dianti_wrap" v-if="showFloor">
      <!-- <div class="dianti_center"> -->
      <div style="width: 1346px; margin: auto; position: relative">
        <div
          style="
            width: 105px;
            position: absolute;
            left: -127px;
            text-align: end;
          "
        >
          <div
            v-for="(item, index) in liftData"
            :key="index"
            class="lift_item"
            :class="{ active: activeIndex == index }"
            @mouseenter="enterFloor(item, index)"
            @mouseleave="leaveFloor(item)"
            @click="scrollFloor(item, index)"
          >
            <div class="lift_title">
              {{
                activeIndex == index
                  ? item.json_data.data.titleName
                  : mouseIndex == index
                  ? item.json_data.data.titleName
                  : index + 1 + "F"
              }}
            </div>
            <div class="lift_line" v-if="activeIndex == index"></div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div style="height: 100%; overflow: auto" ref="scrollPage">
      <NavTopBar v-if="isTopic == false"/>
      <SldHomeTopSearch :showSearch="searchBarFixed"  v-if="isTopic == false"/>
      <NavCatHeader  v-if="isTopic == false"/>
      <div class="index">
        <template  v-if="isTopic == false">
          <div class="skeleton_banner"></div>
          <div class="w_sld_react_1210 adv_04_wrap skeleton">
            <div class="floor_title">
              <h2>
                <div>&nbsp;</div>
                <span></span>
                <div>&nbsp;</div>
              </h2>
            </div>
            <div class="floor_goods">
              <div
                class="item"
                v-for="(item_main, index_main) in [
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                ]"
                v-bind:key="index_main"
              >
                <div class="wrap">
                  <a href="javascript:void(0)" class="example_text"></a>
                  <p class="title">
                    <a href="javascript:void(0)">{{ item_main }}</a>
                  </p>
                  <p class="price">
                    <span></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>

        <SldDiy
          ref="sldDiyRef"
          v-if="decorateData.data.length"
          :decorateData="decorateData"
          @adv19="handleAdv19"
          @getDada="getDada"
          :background="pageColor"
          :banner="bannerList"
          :isTopic="isTopic"
        />
        <OpenScreen
          @closeScreen="closeScreen"
          :advImg="advImg"
          :advInfo="advInfo"
          v-if="isTopic == false"
        >
        </OpenScreen>
        <!-- 空页面 start-->
        <SldCommonEmpty
          v-if="!firstLoading && !decorateData.data.length"
          totalHeight="900"
          paddingTop="250"
          :tip="L['我们正在努力装修中，敬请期待～']"
        />
        <!-- 空页面 end-->
        <div
           v-if="isTopic == false"
          class="side_menu"
          @mouseenter="clickSideMenu"
          @mouseleave="hideSideMenuInfo"
        >
          <div
            class="item_list"
            style="height: 292px"
            v-if="showKefu && showKefuIndex == 0"
            @mouseenter="mouseEnter(0)"
            @mouseleave="mouseLeave(0)"
          >
            <div
              class="list"
              :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
            >
              <div
                class="list_item"
                :style="index == 3 ? 'border-bottom:none' : ''"
                v-for="(item, index) in sideMenuInfo"
                :key="index"
              >
                <div class="item_title">{{ item.title }}</div>
                <div class="item_info">{{ item.info }}</div>
              </div>
            </div>
          </div>
          <div
            class="item_list"
            style="height: 292px"
            v-if="showKefu && showKefuIndex == 1"
            :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
            @mouseenter="mouseEnter(1)"
            @mouseleave="mouseLeave(1)"
          >
            <div class="list">
              <div
                class="list_item"
                v-for="(item, index) in sideMenuInfo"
                :key="index"
              >
                <div class="item_title">{{ item.title }}</div>
                <div class="item_info">{{ item.info }}</div>
              </div>
              <div class="list_item" style="border-bottom: none">
                <div
                  class="item_title"
                  style="font-size: 15px; margin-bottom: 5px"
                >
                  服务时间:24h
                </div>
                <div class="item_info" style="font-size: 15px">周一~周日</div>
              </div>
            </div>
          </div>

          <!-- v-if="showKefu && showKefuIndex == 2" -->
          <div
            class="item_list"
            style="height: 310px; overflow-y: auto"
            v-if="showKefu && showKefuIndex == 2"
            :style="{ marginTop: 83 * Number(showKefuIndex) + 'px' }"
            @mouseenter="mouseEnter(2)"
            @mouseleave="mouseLeave(2)"
          >
            <div class="list">
              <div class="coupon_title">
                <div class="title">优惠券</div>
                <div class="btn">一键领取</div>
              </div>
              <div
                class="coupon_item"
                v-for="(item, index) in couponData"
                :key="index"
              >
                <img src="../../assets/coupon_bg.png" alt="" />
                <div class="item_info">
                  <div class="item_price">
                    <div class="price">￥{{ item.limitQuota }}</div>
                    <div class="coupon">
                      <div class="coupon_name">{{ item.couponName }}</div>
                      <div class="coupon_content">{{ item.couponContent }}</div>
                    </div>
                  </div>

                  <!-- <div class="coupon">优惠券</div> -->
                  <div class="info">
                    {{ item.effectiveStart.split(" ")[0] }} -
                    {{ item.effectiveEnd.split(" ")[0] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="item_list"
            style="height: 128px"
            v-if="showKefu && showKefuIndex == 3"
            :style="{
              marginTop: showCoupon
                ? 83 * Number(showKefuIndex) + 'px'
                : 83 * (Number(showKefuIndex) - 1) + 'px',
            }"
            @mouseenter="mouseEnter(3)"
            @mouseleave="mouseLeave(3)"
          >
            <div class="list">
              <div class="gift_box">
                <div class="title">注册即享</div>
                <div class="title">888元大礼包</div>
                <div class="btn">注册领取</div>
              </div>
            </div>
          </div>
          <div
            class="menu_box"
            :style="
              expand
                ? showCoupon
                  ? 'height:332px'
                  : 'height:249px'
                : 'height:83px'
            "
          >
            <div class="item" @mouseenter="showSideMenuInfo('0')">
              <img src="../../assets/service/kefu.png" alt="" />
              <div>咨询客服</div>
            </div>
            <div v-if="expand">
              <div class="item" @mouseenter="showSideMenuInfo('1')">
                <img src="../../assets/service/kefuphone.png" alt="" />
                <div>400热线</div>
              </div>
              <div
                class="item"
                @mouseenter="showSideMenuInfo('2')"
                v-if="showCoupon"
              >
                <img src="../../assets/service/coupon.png" alt="" />
                <div>优惠券</div>
              </div>
              <div class="item" @mouseenter="showSideMenuInfo('3')">
                <img src="../../assets/service/gift.png" alt="" />
                <div>新人礼</div>
              </div>
              <div class="expand_arrow" @click="changeExpand">
                <img
                  src="../../assets/expand_arrow.png"
                  style="transform: rotate(180deg)"
                  alt=""
                />
              </div>
            </div>

            <div v-else class="expand_arrow" @click="changeExpand">
              <img src="../../assets/expand_arrow.png" alt="" />
            </div>
            <div class="top_box" style="margin-top: 30px" @click="goTop">
              <div class="item">
                <img src="../../assets/top.png" alt="" />
                <div>回到顶部</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterService  v-if="isTopic == false"/>
      <FooterLink  v-if="isTopic == false"/>
    </div>
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref, onMounted, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  handleTime,
  getTodayStartTimestamp,
  getTodayEndTimestamp,
} from "../../utils/common";
import SldDiy from "../../components/SldDiy";
import OpenScreen from "../../components/OpenScreen";
import { useStore } from "vuex";
import SldCommonEmpty from "../../components/SldCommonEmpty";
import NavTopBar from "../../components/NavTopBar";
import SldHomeTopSearch from "../../components/SldHomeTopSearch";
import NavCatHeader from "../../components/NavCatHeader";
import FooterService from "../../components/FooterService";
import FooterLink from "../../components/FooterLink";
export default {
  name: "index",
  components: {
    SldDiy,
    OpenScreen,
    SldCommonEmpty,
    NavTopBar,
    SldHomeTopSearch,
    NavCatHeader,
    FooterService,
    FooterLink,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const adv_21_right_icon = require("../../assets/decorate/right_more_icon.png");
    const adv_24_let_default_pic = require("../../assets/decorate/adv_24_let_default_pic.png");
    const decorateData = reactive({ data: [] }); //装修数据
    const openScreenData = reactive({ data: {} }); //开屏数据
    const firstLoading = ref(true); //是否第一次加载
    const { proxy } = getCurrentInstance();
    const show_open_screen = ref(true);
    const store = useStore();
    const L = proxy.$getCurLanguage();
    const expand = ref(false);
    const showKefu = ref(false);
    const showKefuIndex = ref("");
    const sideMenuInfo = ref([]);
    const showCoupon = ref(false);
    const activeIndex = ref(null);
    const sldDiyRef = ref(null);
    const scrollPage = ref(null);
    const clickSide = ref(false);
    const clickInfo = ref(false);
    const advTop = ref([]);
    const topAdvs = ref([]);
    const topList = ref([]);
    const topImg = ref("");
    const topInfo = ref({});
    const showTopImage = ref(false);
    const liftData = ref([]);
    const couponData = ref([]);
    const mouseIndex = ref(null);
    const showSideMenu = ref(false);
    const showFloor = ref(false);
    const searchBarFixed = ref(false);
    const advList = ref([]);
    const advImg = ref("");
    const advInfo = ref({});
    const showXcxImage = ref(false);
    const pageColor = ref("");
    const bannerList = ref([]);
    const isTopic = ref(false);
    
    const closeAd = () => {
      // 隐藏广告
      document.querySelector(".home_adv_con").style.display = "none";
    };
    const getAdv = () => {
      proxy.$post("v3/system/front/pcAdv/list").then((res) => {
        if (res.state == 200) {
          advTop.value = res.data.openAdvs;
          topAdvs.value = res.data.topAdvs;
          let banner = res.data.bannerAdvs;
          if (banner.length == 0) {
            bannerList.value = [];
          } else {
            banner.forEach((i) => {
              let item = JSON.parse(i.data);
              item.toufangIsShow = true;
              if (item.deliverySettings) {
                if (!handleTime(item.deliveryTime)) {
                  item.toufangIsShow = false;
                } else {
                  if (item.deliveryGroup != 1) {
                    //根据个人信息判断展不展示
                  }
                }
              }
              i.datas = item;
            });
            bannerList.value = banner.filter(
              (e) => e.datas.toufangIsShow && e.datas.imgUrl
            );
            console.log("bannerList.value========", bannerList.value);
          }

          if (advTop.value && advTop.value.length != 0) {
            let time = new Date().getTime();
            let showAdvTime = localStorage.getItem("showAdvTime");
            if (showAdvTime && showAdvTime >= time) {
            } else {
              advTop.value.forEach((item) => {
                item.data = JSON.parse(item.data);
              });
              // this.advList = advList;
              let storeList = localStorage.getItem("advList");
              if (storeList && storeList.length !== 0) {
                advList.value = advTop.value.map((obj) => {
                  let objToMerge = storeList.find((o) => o.advId == obj.advId);
                  return Object.assign({}, objToMerge, obj);
                });
              } else {
                advList.value = advTop.value;
              }
              let hasShow = advList.value.filter((item) => !item.showAdv);
              if (hasShow.length == 0) {
                advList.value.forEach((v) => {
                  v.showAdv = false;
                });
              }

              if (advList.value.length != 0 && !store.state.firstShowAdv) {
                for (let i = 0; i < advList.value.length; i++) {
                  if (!advList.value[i].showAdv) {
                    let time = new Date().getTime();
                    if (
                      advList.value[i].showTime &&
                      advList.value[i].showTime >= time
                    ) {
                    } else {
                      advList.value[i].showAdv = true;
                      console.log(advList);
                      advImg.value = advList.value[i].data.imgUrl;
                      advList.value[i].showTime = getTodayEndTimestamp();
                      advInfo.value = advList.value[i].data;
                      showXcxImage.value = true;
                      console.log("advImg", advImg.value);
                      break;
                    }
                    // console.log(i, this.advList[i], this.advList[i].showAdv)
                  }
                }
                // console.log("advList", this.advList)
                store.commit("setAdvList", advList.value);
                // localStorage.setItem("advList", advList.value)
                store.commit("setFirstShowAdv", true);
                let endTime = getTodayEndTimestamp();
                localStorage.setItem("showAdvTime", endTime);
              }
            }
          }

          if (topAdvs.value && topAdvs.value.length != 0) {
            let time = new Date().getTime();
            let showTopTime = localStorage.getItem("showTopTime");
            if (showTopTime && showTopTime >= time) {
            } else {
              topAdvs.value.forEach((item) => {
                item.data = JSON.parse(item.data);
              });
              let storeList = localStorage.getItem("topList");
              if (storeList && storeList.length !== 0) {
                topList.value = topAdvs.value.map((obj) => {
                  let objToMerge = storeList.find((o) => o.advId == obj.advId);
                  return Object.assign({}, objToMerge, obj);
                });
              } else {
                topList.value = topAdvs.value;
              }
              let hasShow = topList.value.filter((item) => !item.showAdv);

              if (hasShow.length == 0) {
                topList.value.forEach((v) => {
                  v.showAdv = false;
                });
              }

              if (topList.value.length != 0 && !store.state.firstShowTop) {
                for (let i = 0; i < topList.value.length; i++) {
                  if (!topList.value[i].showAdv) {
                    // console.log(i, this.advList[i], this.advList[i].showAdv)

                    topList.value[i].showAdv = true;

                    topImg.value = topList.value[i].data.imgUrl;
                    topInfo.value = topList.value[i].data;
                    showTopImage.value = true;
                    break;
                  }
                }
                let endTime = getTodayEndTimestamp();
                localStorage.setItem("showTopTime", endTime);
                console.log("topList", topList.value);
                store.commit("setTopList", topList.value);
                store.commit("setFirstShowTop", true);
              }
            }
          }
        }
      });
    };
    const navTo = (topInfo) => {
      proxy.$diyNavTo(topInfo);
    };
    const getInitData = () => {
      
      isTopic.value = route.query.topic == 1
      let draft = route.query.draft;

      let param = {};
      param.decoId = route.query.id;
      proxy.$get("v3/system/front/pcDeco/display", param).then((res) => {
        firstLoading.value = false;
        
        if (res.state == 200) {
          console.log('res',res);
          console.log(' res.data.draft', res.data.draft);
          if (draft == 1) {
            let data = JSON.parse(
              res.data.draft.replace(/&quot;/g, '"')
            );
            decorateData.data = data.filter(
              (i) => i.json && i.json != 'undefined'
            );

          } else {
            let data = JSON.parse(
              res.data.data.replace(/&quot;/g, '"')
            );
            decorateData.data = data.filter(
              (i) => i.json && i.json != 'undefined'
            );
          }
          console.log('hhhhh',decorateData);
          decorateData.data.map((item) => {
            console.log('decorateData item',item);
            item.json_data = item.json;
            if (item.json_data && item.json_data.type == "adv_19") {
              item.json_data.data.map((child) => {
                child.cur_tab = 0;
              });
            }
            if (item.json_data && item.json_data.type == "main_banner") {
              pageColor.value = item.page_color;
            }
            if (item.json_data && item.json_data.type == "oneEight") {
              let ids = [];
              item.json_data.imgArr.forEach((i) => {
                ids.push(i.productId);
              });
              getProductData(ids, "oneEight");
            } else if (item.json_data && item.json_data.type == "twoEight") {
              let twoIds = [];
              item.json_data.imgArr.forEach((i) => {
                twoIds.push(i.productId);
              });
              getProductData(twoIds, "twoEight");
            } else if (item.json_data && item.json_data.type == "zeroFive") {
              let zeroIds = [];
              item.json_data.imgArr.forEach((i) => {
                zeroIds.push(i.productId);
              });
              getProductData(zeroIds, "zeroFive");
            }
          });

          liftData.value = decorateData.data.filter(
            (i) => i.json_data && i.json_data.type == "text_title"
          );
          let couponData = decorateData.data.filter(
            (i) => i.json_data && i.json_data.type == "coupon_fixed" && i.json_data.state != 4
          );
          if (couponData.length != 0) {
            getCouponList(couponData[0].json_data);
          } else {
            showCoupon.value = false;
          }
          console.log(11, decorateData.data);
          // let data = decorateData.data.filter(
          //   (i) => i.json_data.type == "text_title"
          // );
          // proxy.$emit("childData", data);
        }
      });
    };
    const getProductData = async (arr, type) => {
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      let param = {
        productIds: arr,
      };
      proxy
        .$post("v3/goods/front/goods/productList", param, config)
        .then((res) => {
          if (res.state == 200) {
            res.data.list.forEach((i) => {
              i.fresh = true;
            });
            decorateData.data.map((item) => {
              if (item.json_data && item.json_data.type == type) {
                // item.json_data.info = res.data.list;
                let mergedArray = item.json_data.imgArr.map((item1) => {
                  let item2 = res.data.list.find(
                    (items) => items.productId == item1.productId
                  );
                  return {
                    ...item1,
                    ...item2,
                  };
                });
                console.log("imgArr========", mergedArray);
                item.json_data.info = mergedArray;
              }
            });
          }
        });
    };
    const getCouponList = async (data) => {
      let ids = [];
      data.data.forEach((i) => {
        ids.push(i.couponId);
      });
      let param = {
        couponIds: ids,
      };
      let config = {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
        },
      };
      proxy
        .$post("/v3/promotion/front/coupon/diyHomeCouponList", param, config)
        .then((res) => {
          if (res.state == 200) {
            console.log(res);
            couponData.value = res.data;
            showCoupon.value = true;
          }
        });
    };
    const getDada = () => {
      // const rect = scrollPage.value.$el
      scrollPage.value.addEventListener("scroll", handleScroll);
    };
    const handleScroll = (event) => {
      // console.log(event);
      if(!isTopic){
        if (event.target.scrollTop >= 250) {
          showSideMenu.value = true;
          showFloor.value = true;
          searchBarFixed.value = true;
        } else if (event.target.scrollTop < 250) {
          showSideMenu.value = false;
          showFloor.value = false;
          searchBarFixed.value = false;
        }
        // console.log("showSearch========", searchBarFixed.value);
        var viewportHeight =
          window.innerHeight || document.documentElement.clientHeight;
        var documentHeight = document.body.scrollHeight;
        if (event.target.scrollTop >= 500) {
          showFloor.value = true;
        }
        if (event.target.scrollHeight - event.target.scrollTop < 1000) {
          // console.log(11)
          showFloor.value = false;
        }
      }


      //  liftData.value = decorateData.data.filter(
      //   (i) => i.json_data.type == "text_title"
      // );
      // 处理滚动事件
      proxy.$nextTick(() => {
        // console.log(liftData.value);
        liftData.value.forEach((item, index) => {
          const scrollContainer =
            sldDiyRef.value.$refs["scroll" + item.json.data.id];
          // console.log(scrollContainer);
          // scrollContainer.forEach((item, index) => {
          if (index == 0) {
            if (
              event.target.scrollTop <
              scrollContainer[0].offsetParent.offsetTop +
                scrollContainer[0].offsetTop -
                100
            ) {
              activeIndex.value = null;
              // console.log(activeIndex.value);
            }
          }
          if (
            event.target.scrollTop >=
            scrollContainer[0].offsetParent.offsetTop +
              scrollContainer[0].offsetTop -
              100
          ) {
            activeIndex.value = index;
            // console.log(activeIndex.value);
          }
          // console.log(event.target.scrollTop,scrollContainer[0].offsetParent.offsetTop,scrollContainer[0].offsetTop);
          // });
        });
      });
    };
    const getOpenScreen = () => {
      // proxy.$post("v3/system/front/pcAdv/list").then((res) => {
      //   if (res.state == 200) {
      //     openScreenData.data = JSON.parse(
      //       res.data.data);
      //     if (
      //       openScreenData.data.imgUrl &&
      //       openScreenData.data.show_switch &&
      //       !route.query.type
      //     ) {
      //       if (JSON.stringify(store.state.openScreenInfo) == "{}") {
      //         openScreenData.data.time = new Date().getTime();
      //         store.commit("updateOpenScreenInfo", openScreenData.data);
      //         show_open_screen.value = true;
      //         document.body.style.overflow = "hidden";
      //       } else if (
      //         store.state.openScreenInfo.show_radio_sele ==
      //         openScreenData.data.show_radio_sele
      //       ) {
      //         if (store.state.openScreenInfo.show_radio_sele == "one") {
      //           if (openScreenData.data.time - new Date().getTime() > 86400) {
      //             openScreenData.data.time = new Date().getTime();
      //             store.commit("updateOpenScreenInfo", openScreenData.data);
      //             show_open_screen.value = true;
      //             document.body.style.overflow = "hidden";
      //           }
      //         } else if (store.state.openScreenInfo.show_radio_sele == "more") {
      //           store.commit("updateOpenScreenInfo", openScreenData.data);
      //           show_open_screen.value = true;
      //           document.body.style.overflow = "hidden";
      //         }
      //       } else {
      //         openScreenData.data.time = new Date().getTime();
      //         store.commit("updateOpenScreenInfo", openScreenData.data);
      //         show_open_screen.value = true;
      //         document.body.style.overflow = "hidden";
      //       }
      //     }
      //   }
      // });
    };
    const closeScreen = () => {
      showXcxImage.value = false;
      // document.body.style.overflow = "";
    };
    router.beforeEach((to, from, next) => {
      document.body.style.overflow = "";
      next();
    });

    const changeExpand = () => {
      expand.value = !expand.value;
    };
    const handleAdv19 = (data) => {
      let tmp_data = decorateData.data.filter(
        (item) => item.dataId == data.dataId
      )[0];
      tmp_data.json_data.data[data.left_or_right_index]["cur_tab"] =
        data.tab_index;
    };
    const showSideMenuInfo = (index) => {
      console.log("you");
      expand.value = true;
      showKefuIndex.value = index;
      clickSide.value = true;
      switch (index) {
        case "0":
          sideMenuInfo.value = [
            {
              title: "售前咨询,获取更多优惠",
              info: "9:00~24:00",
            },
            {
              title: "订单售后，华硕商城购买",
              info: "9:00~24:00",
            },
            {
              title: "官网咨询技术",
              info: "9:00~22:00",
            },
            {
              title: "华硕小二，享全方位服务",
              info: "9:00~24:00",
            },
          ];
          break;
        case "1":
          sideMenuInfo.value = [
            {
              title: "笔记本服务热线",
              info: "400-600-6655",
            },
            {
              title: "ROG产品服务热线",
              info: "400-616-6655",
            },
            {
              title: "DIY产品服务热线",
              info: "400-620-6655",
            },
          ];
          break;
      }
      showKefu.value = true;
    };
    const mouseEnter = (index) => {
      showKefuIndex.value = index;
    };
    const mouseLeave = (index) => {
      clickInfo.value = false;
      if (!clickSide.value) {
        setTimeout(() => {
          showKefu.value = false;
          expand.value = false;
          // clickSide.value = false
        }, 2000);
      } else {
      }
    };
    const hideSideMenuInfo = () => {
      clickSide.value = false;
      clickInfo.value = false;
      showKefu.value = false;
      expand.value = false;
    };
    const clickSideMenu = () => {
      clickSide.value = true;
    };
    const enterFloor = (item, index) => {
      mouseIndex.value = index;
    };
    const leaveFloor = (item) => {
      mouseIndex.value = null;
    };
    const scrollFloor = (item, index) => {
      // activeIndex.value = index;
      liftData.value.forEach((i) => {
        if (item.json.data.id == i.json.data.id) {
          const scrollContainer =
            sldDiyRef.value.$refs["scroll" + item.json.data.id];
          scrollPage.value.scrollTo({
            // behavior: "smooth",
            top:
              scrollContainer[0].offsetParent.offsetTop +
              scrollContainer[0].offsetTop -
              100,
          });
        }

        // console.log(event.target.scrollTop,scrollContainer[0].offsetParent.offsetTop,scrollContainer[0].offsetTop);
        // });
      });
    };
    const goTop = () =>{
      scrollPage.value.scrollTo({
            behavior: "smooth",
            top: 0,
          });
    }
    onMounted(() => {
      //getAdv();
      //getOpenScreen();
      getInitData();
    });

    return {
      adv_21_right_icon,
      adv_24_let_default_pic,
      decorateData,
      firstLoading,
      show_open_screen,
      openScreenData,
      sldDiyRef,
      handleAdv19,
      closeScreen,
      L,
      expand,
      showKefu,
      showKefuIndex,
      sideMenuInfo,
      showCoupon,
      activeIndex,
      advTop,
      liftData,
      couponData,
      scrollPage,
      mouseIndex,
      showSideMenu,
      showFloor,
      topAdvs,
      showXcxImage,
      advImg,
      advInfo,
      showTopImage,
      topImg,
      topInfo,
      changeExpand,
      showSideMenuInfo,
      mouseEnter,
      mouseLeave,
      hideSideMenuInfo,
      clickSideMenu,
      closeAd,
      handleScroll,
      getDada,
      scrollFloor,
      leaveFloor,
      enterFloor,
      navTo,
      goTop,
      searchBarFixed,
      pageColor,
      bannerList,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../style/decorate.scss";

// .bottom_line {
//   width: 100%;
// }

.dianti_wrap {
  position: absolute;
  top: calc(50% - 20px);
  // transform: translateY(-50%);
  width: 100%;
  /* left: 194px; */
  z-index: 9999;
  /* width: 1336px; */
  /* display: flex; */
  /* justify-content: center; */
}

.dianti_center {
  display: flex;
  justify-content: center;
}

.lift_item {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #888e98;
  line-height: 22px;
  margin-bottom: 15px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  /* text-align: end; */
}

.lift_title {
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.lift_line {
  // margin-left: 5px;
  width: 2px;
  height: 12px;
  background: #000000;
}

.active {
  font-family: Microsoft YaHei,Microsoft YaHei ;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  line-height: 22px;
}

.home_adv_con {
  overflow: hidden;
  height: 100px;
  position: relative;
  margin: 0 auto;
  width: 100%; /* 确保广告容器占满父元素的宽度 */
}

.home_adv {
  background-image: url("../../assets/test_logo.png");
  width: 100%;
  height: 100px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

// .adv1200 {
//   width: 1920px;
//   height: 100px;
//   margin: 0 auto;
//   position: relative;
// }

.close1 {
  top: 15px;
  right: 15px;
  z-index: 2;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  box-sizing: border-box; /* 确保内边距不影响整体大小 */
  padding: 3px; /* 添加内边距，使图标与容器边缘有距离 */
}

.close1 svg {
  width: 100%;
  height: 100%;
  fill: #fff; /* 设置图标颜色 */
}

.index {
  min-height: 456px;
  // background: #f8f8f8;
  padding-bottom: 10px;
}

.skeleton_banner {
  width: 100%;
  height: 470px;
  background: $colorSkeleton;
  margin-bottom: 10px;
}

.skeleton {
  &.adv_04_wrap .floor_title h2 span {
    background: $colorSkeleton;
    display: inline-block;
    width: 200px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .title {
    background: $colorSkeleton;
    width: 100%;

    a {
      color: transparent;
    }
  }

  &.adv_04_wrap .floor_goods .item .wrap .price {
    width: 100%;
    height: 25px;
  }

  &.adv_04_wrap .floor_goods .item .wrap .price span {
    display: inline-block;
    width: 70px;
    height: 100%;
    background: $colorSkeleton;
  }
}

.side_menu {
  position: absolute;
  top: calc(100vh - 676px);
  right: 30px;
  z-index: 999;
  display: flex;

  .menu_box {
    position: relative;
    width: 80px;
    text-align: center;
    background: #ffffff;
    // box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    cursor: pointer;
    box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #f2f2f2;
    .item {
      padding: 15px 0;
      height: 83px;

      img {
        width: 30px;
        height: 30px;
      }

      div {
        margin-top: 5px;
        font-family: Microsoft YaHei,Microsoft YaHei ;
        font-weight: 400;
        font-size: 12px;
        color: #7e91bc;
        line-height: 18px;
        text-align: center;
      }
    }
    .item:hover {
      background: rgba(175, 182, 194, 0.1);
    }
    .expand_arrow {
      position: absolute;
      bottom: -15px;
      left: 25px;
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 50%;
      // line-height: 30px;
      text-align: center;

      img {
        margin-top: 5px;
        width: 20px;
        height: 20px;
      }
    }
    .top_box {
      box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #f2f2f2;
      background: #ffffff;
    }
  }

  .item_list {
    position: relative;
    background: #ffffff;
    margin-right: 5px;
    cursor: pointer;
    box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #f2f2f2;
    // text-align: center;
    .list {
      width: 185px;

      .list_item {
        padding: 14px 0 14px 10px;
        border-bottom: 1px solid rgba(175, 182, 194, 0.1);
        .item_title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
          margin-bottom: 5px;
        }

        .item_info {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #7e91bc;
          line-height: 18px;
        }
      }
      .list_item:hover {
        background: rgba(175, 182, 194, 0.1);
      }
      .coupon_title {
        display: flex;
        padding: 16px 10px;

        .title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .btn {
          margin-left: 10px;
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 14px;
          text-align: center;
          background: #1e7cff;
          border-radius: 2px;
          padding: 5px 10px;
        }
      }

      .coupon_item {
        position: relative;

        img {
          position: relative;
          width: 175px;
          height: 76px;
          margin: 0 5px;
        }

        .item_info {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items: center;

          .item_price {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 10px auto 14px;

            .price {
              font-family: Microsoft YaHei,Microsoft YaHei ;
              font-weight: 600;
              font-size: 20px;
              color: #df443b;
              line-height: 30px;
              text-align: center;
              // margin-top: 5px;
            }

            .coupon {
              padding-left: 13px;
              width: 86px;

              .coupon_name {
                font-family: Microsoft YaHei,Microsoft YaHei;
                font-weight: 400;
                font-size: 9px;
                color: #000000;
                line-height: 15px;
                overflow: hidden;
                text-overflow: ellipsis; //文本溢出显示省略号
                white-space: nowrap; //文本不会换行
              }

              .coupon_content {
                font-family: Microsoft YaHei,Microsoft YaHei;
                font-weight: 400;
                font-size: 9px;
                color: #888e98;
                line-height: 15px;
              }
            }
          }

          .info {
            font-family: Microsoft YaHei,Microsoft YaHei;
            font-weight: 400;
            font-size: 9px;
            color: #888e98;
            line-height: 15px;
            text-align: center;
          }
        }
      }

      .gift_box {
        height: 128px;
        background: #ffffff;
        box-shadow: 0px 8px 16px 0px rgba(84, 86, 96, 0.05);
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #f2f2f2;
        text-align: center;
        padding: 20px 0;

        .title {
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .btn {
          text-align: center;
          margin: 20px auto;
          width: 68px;
          height: 24px;
          background: #1e7cff;
          border-radius: 2px 2px 2px 2px;
          font-family: Microsoft YaHei,Microsoft YaHei ;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }
  }
  // .item_list::-webkit-scrollbar{
  //   width: 5px;
  // }
}
</style>
